const Search = ({ term, setTerm }) => {
  const handleOnChange = (event) => {
    event.preventDefault();
    setTerm(event.target.value);
  };

  return (
    <input
      className="faq-search"
      type="text"
      id="search"
      placeholder="Search"
      name="search"
      onChange={handleOnChange}
      value={term}
    />
  );
};

export default Search;
